module.exports = __webpack_public_path__ + "static/portfolio_gallery_26-74e6f1a66d55845690a3ff01504ff014.jpg";